import React from "react";

import { IgButton } from "@intelligems/ig-theme";
import { ButtonProps } from "@mui/material";

export const CancelButton = (props: ButtonProps) => {
  return (
    <IgButton variant="contained" color="secondary" sx={{ flex: 1 }} {...props}>
      Cancel
    </IgButton>
  );
};
